import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
    franchiseIncomeAccounts: null,
    lastState: null,
    lastScope: null
};

const franchiseIncomeAccountsReducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.FRANCHISEINCOMEACCOUNT_START: {
            return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
        }
        case actionTypes.FRANCHISEINCOMEACCOUNT_SUCCESS: {
            return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
        }
        case actionTypes.FRANCHISEINCOMEACCOUNT_FAIL: {
            return updateState(state, { lastState: constants.STATE_FAIL });
        }
        case actionTypes.FRANCHISEINCOMEACCOUNT_LISTRESET: {
            return updateState(state, { ...action.data, lastState: constants.STATE_RESET, lastScope: 'reset' });
        }
        default: {
            return state;
        }
    }
};

export default franchiseIncomeAccountsReducer;
